'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import PortalIdParser from 'PortalIdParser';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import I18n from 'I18n';
import { usageTracker } from 'AdsUI/lib/usageTracker';
import UITruncateString from 'UIComponents/text/UITruncateString';
import UITable from 'UIComponents/table/UITable';
import Small from 'UIComponents/elements/Small';
import UILink from 'UIComponents/link/UILink';

const Deal = ({
  deal
}) => {
  const name = deal.properties.dealname ? deal.properties.dealname.value : I18n.text('untitledDeal');
  const id = deal.dealId;
  const url = `/contacts/${PortalIdParser.get()}/deal/${id}`;
  return /*#__PURE__*/_jsx(UILink, {
    href: url,
    target: "_blank",
    onClick: () => {
      usageTracker.track('clickedDealContact');
    },
    children: /*#__PURE__*/_jsx(UITruncateString, {
      children: name
    })
  });
};

const DealList = ({
  total,
  deals
}) => /*#__PURE__*/_jsxs("div", {
  children: [/*#__PURE__*/_jsx("div", {
    className: "m-y-3",
    children: /*#__PURE__*/_jsxs(Small, {
      use: "help",
      children: [I18n.formatNumber(total), ' ', /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "contactList.newDeals"
      })]
    })
  }), /*#__PURE__*/_jsxs(UITable, {
    children: [/*#__PURE__*/_jsx("thead", {
      children: /*#__PURE__*/_jsx("tr", {
        children: /*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "name"
          })
        })
      })
    }), /*#__PURE__*/_jsx("tbody", {
      children: deals.map(deal => /*#__PURE__*/_jsx("tr", {
        className: "detail-pages-person",
        children: /*#__PURE__*/_jsx("td", {
          children: /*#__PURE__*/_jsx(Deal, {
            deal: deal
          })
        })
      }, deal.dealId))
    })]
  })]
});

DealList.propTypes = {
  deals: PropTypes.array.isRequired,
  total: PropTypes.number.isRequired
};
export default DealList;